import React from "react";

import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";

import { Box } from "@mui/system";
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import GavelIcon from "@mui/icons-material/Gavel";
import { Button, Typography } from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import ForwardIcon from '@mui/icons-material/Forward';
import HowToRegIcon from "@mui/icons-material/HowToReg";
import CarRepairIcon from '@mui/icons-material/CarRepair';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import MinorCrashIcon from "@mui/icons-material/MinorCrash";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

import useGetPracticesStats from "../../hooks/practices/useGetPracticesStats";

const PracticesCounterDisplayer = ({ user, status, userCode, timeQuery }) => {
  const practicesCount = useGetPracticesStats(status, userCode, timeQuery);

  return (
    <Box
      disabled={userCode}
      component={Button}
      onClick={() => {
        if (user === "Controller")
          window.location.href = `/area_controller/pratiche?where_key=status&where_value=${status}`;
      }}
      sx={{
        display: "block",
        textDecoration: "none",
        transition: "transform 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.1)",
          border: "5px solid #005ca9",
          boxShadow: 10,
        },
        "&:active": {
          transform: "translateY(-20px)",
          transition: "transform 0.2s",
        },
        "&:disabled": { color: "white" },
        color: "white",
        background:
          status === "Nuova"
            ? "#42c4f5"
            : status === "Presa in carico"
              ? "#42a5f5"
              : status === "Richiesta danni inviata"
                ? "purple"
                : status === "Attesa conti perito"
                  ? "goldenrod"
                  : status === "Inviata stima di parte"
                    ? "#85d016"
                    : status === "Attesa conti perizia integrativa"
                      ? "tan"
                      : status === "Attesa documentazione riparazioni"
                        ? "palevioletred"
                        : status === "Attesa fattura riparazioni"
                          ? "violet"
                          : status === "Inviata documentazione per pagamento"
                            ? "orange"
                            : status === "Trattativa con liquidatore"
                              ? "darkorchid"
                              : status === "Liquidata"
                                ? "green"
                                : status === "Contestata"
                                  ? "red"
                                  : status === "Dismesso mandato"
                                    ? "crimson"
                                    : status === "Contenzioso" && "orangered",
        width: "32%",
        height: 100,
        mb: 1,
        borderRadius: 2,
        boxShadow: 2,
        p: 1,
      }}
    >
      {status === "Nuova" ? (
        <NewReleasesIcon />
      ) : status === "Presa in carico" ? (
        <HowToRegIcon />
      ) : status === "Richiesta danni inviata" ? (
        <>
          <DriveFileMoveIcon />
          <AccountBalanceIcon />
        </>
      ) : status === "Attesa conti perito" ? (
        <>
          <PersonSearchIcon />
          <HourglassTopIcon />
        </>
      ) : status === "Inviata stima di parte" ? (
        <>
          <MinorCrashIcon />
          <ForwardIcon />
        </>
      ) : status === "Attesa conti perizia integrativa" ? (
        <>
          <PersonSearchIcon />
          <AddIcon />
        </>
      ) : status === "Attesa documentazione riparazioni" ? (
        <>
          <HourglassTopIcon />
          <CarRepairIcon />
        </>
      ) : status === "Attesa fattura riparazioni" ? (
        <>
          <HourglassTopIcon />
          <ReceiptIcon />
        </>
      ) : status === "Inviata documentazione per pagamento" ? (
        <>
          <RequestQuoteIcon />
          <ForwardIcon />
        </>
      ) : status === "Trattativa con liquidatore" ? (
        <>
          <CurrencyExchangeIcon />
          <AccountBalanceIcon />
        </>
      ) : status === "Liquidata" ? (
        <DoneIcon />
      ) : status === "Contestata" ? (
        <CloseIcon />
      ) : status === "Dismesso mandato" ? (
        <PersonOffIcon />
      ) : (
        status === "Contenzioso" && <GavelIcon />
      )}
      <br />
      <Typography
        variant={isMobile ? "subtitle1" : "h6"}
        sx={{
          mt: !isMobile && -1,
          lineHeight: 1,
          fontWeight: isMobile && 100,
        }}
      >
        {status}
      </Typography>
      <Typography variant="h5">{practicesCount}</Typography>
    </Box>
  );
};

export default PracticesCounterDisplayer;
